var _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67845 6.60777L9.16874 6.70583V6.70583L8.67845 6.60777ZM8.6 7V7.5C8.83834 7.5 9.04355 7.33177 9.09029 7.09806L8.6 7ZM15.4 7L14.9097 7.09806C14.9565 7.33177 15.1617 7.5 15.4 7.5V7ZM15.3216 6.60777L15.8118 6.50971V6.50971L15.3216 6.60777ZM9.16874 6.70583C9.30896 6.00469 9.92459 5.5 10.6396 5.5V4.5C9.44791 4.5 8.42187 5.34115 8.18816 6.50971L9.16874 6.70583ZM9.09029 7.09806L9.16874 6.70583L8.18816 6.50971L8.10971 6.90194L9.09029 7.09806ZM6 7.5H8.6V6.5H6V7.5ZM4.5 9C4.5 8.17157 5.17157 7.5 6 7.5V6.5C4.61929 6.5 3.5 7.61929 3.5 9H4.5ZM4.5 17V9H3.5V17H4.5ZM6 18.5C5.17157 18.5 4.5 17.8284 4.5 17H3.5C3.5 18.3807 4.61929 19.5 6 19.5V18.5ZM18 18.5H6V19.5H18V18.5ZM19.5 17C19.5 17.8284 18.8284 18.5 18 18.5V19.5C19.3807 19.5 20.5 18.3807 20.5 17H19.5ZM19.5 9V17H20.5V9H19.5ZM18 7.5C18.8284 7.5 19.5 8.17157 19.5 9H20.5C20.5 7.61929 19.3807 6.5 18 6.5V7.5ZM15.4 7.5H18V6.5H15.4V7.5ZM14.8313 6.70583L14.9097 7.09806L15.8903 6.90194L15.8118 6.50971L14.8313 6.70583ZM13.3604 5.5C14.0754 5.5 14.691 6.00469 14.8313 6.70583L15.8118 6.50971C15.5781 5.34115 14.5521 4.5 13.3604 4.5V5.5ZM10.6396 5.5H13.3604V4.5H10.6396V5.5Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 3,
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "matrix(-1 0 0 1 18 9)",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCamera);
export default __webpack_public_path__ + "static/media/ic_camera.a24a7e0f5f24a4ccc5a847f4459f5ef9.svg";
export { ForwardRef as ReactComponent };